import ko from 'knockout';
import resourceHelper from '../../inv-resource-helper/resourceHelper';

/**
 * Resource aria-label binding to display translated aria-label text based on
 * content in the resource files.
 * @example
 * <span data-bind="resAriaLabel: 'Name'"></span>
 * <span data-bind="resAriaLabel: 'Name', params: { fileName: fileName }"></span>
 */
ko.bindingHandlers.resAriaLabel = {
  update: function (element, valueAccessor, allBindings) {

    var value = valueAccessor();
    var params = allBindings.get('params');

    if (value) {
      var text = resourceHelper.getString(ko.utils.unwrapObservable(value));

      if (params) {
        text = resourceHelper.replacePlaceholders(text, params);
      }

      ko.applyBindingsToNode(element, { attr: { 'aria-label': text } });
    }
  }
};
